import React from 'react';

import {
  getMediumProgressFormatted,
  getFormattedDuration,
} from '@fec/assets/js/utils/media-progress';

import './media-time-indicator.scss';

const MediaTimeIndicator = ({ duration, urn }) => {
  if (duration === 0) {
    return null;
  }

  duration = getFormattedDuration(duration);

  // if the media was already started, we display the progress in addition to the duration
  if (urn) {
    const formattedProgress = getMediumProgressFormatted(urn);

    if (formattedProgress) {
      duration = `${formattedProgress} / ${duration}`;
    }
  }

  return <div className="media-time-indicator">{duration}</div>;
};

export default MediaTimeIndicator;
